



import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "../Modal/index";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { IoClose } from "react-icons/io5";
import tv_logo from "../../Image/tv.img.png";
import { supabase, fetchInChunks } from "../../supabaseClient";

import { useNavigate } from "react-router-dom";


export default function AllPagesTV({ showModal, setShowModal, scheduleId }) {
  const [loading, setLoading] = useState(false);
  const [scheduleName, setScheduleName] = useState("");
  const [pagesData, setPagesData] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null);
  const [time, setTime] = useState("");
  const [error, setError] = useState("");
  const [liveOnly, setLiveOnly] = useState(false);
  const [liveTTL, setLiveTTL] = useState([]);
  const [livePageIds, setLivePageIds] = useState([]);
  const [uiLoaded, setUiLoaded] = useState(false);

  const [scheduleMeta, setScheduleMeta] = useState({
    brand: [],
    vendor: [],
    factory: []
  });

  const navigate = useNavigate();


  const [uiTheme, setUiTheme] = useState({
    background: "#000000",
    tileFocus: "#ffffff",
    orbFocus: "#ffffff",
  });


  const minioBaseUrl = "https://images.do.cloudwalker.tv/images/";


  const isCloudwalkerAsset = (url) => {
    if (!url || typeof url !== "string") return false;
    return !url.startsWith("http") || url.includes("images.do.cloudwalker.tv");
  };

  const extractFirstUrl = (raw) => {
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.length > 0 ? parsed[0] : null;
      return parsed || null;
    } catch {
      return (raw && typeof raw === "string" && raw !== "[]") ? raw : null;
    }
  };

  const getImageByRowLayout = (item, row) => {
    const layout = row?.row_layout || "poster";

    // Highlight rows have no real tile fields — their item carries the
    // generated composite image directly under `image`. A plain row's item
    // can ALSO carry `image` — the per-row pin picked in the row builder's
    // tile image picker, saved into that row's own row_items entry — which
    // must win over the tile's own default poster/portrait when present.
    const possibleKeys = layout === "highlight"
      ? ["image", "poster", "portrait"]
      : (layout === "portrait" || layout === "longPortrait")
      ? ["image", "longPortrait", "portrait", "poster"]
      : ["image", layout, "poster", "portrait", "landscape"];

    // Pass 1: Cloudwalker / relative assets only
    for (const key of possibleKeys) {
      const url = extractFirstUrl(item?.[key]);
      if (url && isCloudwalkerAsset(url)) return url;
    }

    // Pass 2: any URL (external CDN last resort)
    for (const key of possibleKeys) {
      const url = extractFirstUrl(item?.[key]);
      if (url) return url;
    }

    return null;
  };
  const resolveImage = (raw) => {
    if (!raw || typeof raw !== "string") return null;

    if (raw.startsWith("http://") || raw.startsWith("https://")) {
      return raw;
    }

    // Highlight composite images are uploaded under "row-assets/..." (already
    // a full relative key) — only bare tile-relative paths need "tiles/" added.
    if (raw.startsWith("tiles/") || raw.startsWith("row-assets/")) {
      return `${minioBaseUrl}${raw}`;
    }
    return `${minioBaseUrl}tiles/${raw}`;
  };

  const isCustomSize = (row) =>
    row?.row_width?.toString().trim() !== "" &&
    row?.row_height?.toString().trim() !== "";



    const FALLBACK_DIMENSIONS = {
  landscape: { w: 710, h: 400 },
  poster: { w: 710, h: 400 },

  main_banner: { w: 1920, h: 500 },
  feature_banner: { w: 1920, h: 300 },
  hero_banner: { w: 1920, h: 900 },

  portrait: { w: 600, h: 800 },

  long_portrait: { w: 300, h: 600 },
  square: { w: 300, h: 300 },

  background: { w: 1920, h: 1080 },
  highlight: { w: 1920, h: 1080 },
};


  // ⏱️ Clock
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      setTime(
        now
          .toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          .toLowerCase()
      );
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);


  const getTTLOutline = (ttlArray, pageId) => {
    const ttlPage = ttlArray.find((t) => t.pid === pageId);
    if (!ttlPage) return { rowOrder: [], tileOrder: {} };

    const rowOrder = ttlPage.rows?.map(r => r.rid) || [];

    const tileOrder = {};
    ttlPage.rows?.forEach(r => {
      tileOrder[r.rid] = r.tiles?.map(t => t.tid) || [];
    });

    return { rowOrder, tileOrder };
  };




  // 🔄 Load schedule and pages


  const getLiveStructureFromTTL = (ttlArray) => {
    if (!Array.isArray(ttlArray)) {
      return { pages: [], ids: [] };
    }

    const now = new Date();

    const livePages = ttlArray
      .map((page) => {
        const pSt = new Date(page.st);
        const pEt = new Date(page.et);
        const pageLive = now >= pSt && now <= pEt;

        console.group(`📄 Page: ${page.pid}`);

        // Process rows (include all rows if page is live, filter by TTL if present)
        const liveRows = (page.rows || [])
          .map((row) => {
            const rSt = row.st ? new Date(row.st) : null;
            const rEt = row.et ? new Date(row.et) : null;
            // Row is live if it has no TTL or its TTL is valid
            const rowLive = !rSt || !rEt || (now >= rSt && now <= rEt);

            console.group(`  🧱 Row: ${row.rid}`);
           

            // Filter tiles strictly
            const liveTiles = (row.tiles || []).filter((t) => {
              const tSt = t.st ? new Date(t.st) : null;
              const tEt = t.et ? new Date(t.et) : null;
              const tLive = !tSt || !tEt || (now >= tSt && now <= tEt);
             
              return tLive;
            });

            
            console.groupEnd();

            // Keep row if it's live (or has no TTL) and has tiles or is explicitly included
            return rowLive ? { ...row, tiles: liveTiles } : null;
          })
          .filter(Boolean);

        
        console.groupEnd();

        // Include page if its TTL is valid (even with no rows)
        return pageLive ? { ...page, rows: liveRows } : null;
      })
      .filter(Boolean);

    const ids = livePages.map((p) => p.pid);
    console.groupEnd();

    return { pages: livePages, ids };
  };

  useEffect(() => {
    if (!showModal || !scheduleId) return;

    const loadData = async () => {
      setLoading(true);
      setError("");
      try {
        const { data: sched, error: schedErr } = await supabase
          .from("scheduling")
          .select("*")
          .eq("id", scheduleId)
          .single();

        if (schedErr) throw schedErr;
        if (!sched) throw new Error("Scheduling not found");

        setScheduleName(sched.name || "Untitled Schedule");

        setScheduleMeta({
          brand: sched.brand || [],
          vendor: sched.vendor || [],
          factory: sched.factory || []
        });


        // Extract TTL & live structure
        const ttlArray = Array.isArray(sched.TTL)
          ? sched.TTL
          : JSON.parse(sched.TTL || "[]");

        const liveStruct = getLiveStructureFromTTL(ttlArray);
        setLiveTTL(liveStruct.pages);
        setLivePageIds(liveStruct.ids);

        // 🟩 Use TTL order directly for preview (NOT DB order)
        const ttlPagesOrdered = ttlArray.map((p) => p.pid);


        // Parse page ids
        let pageIds = [];
        if (Array.isArray(sched.pages)) pageIds = sched.pages;
        else {
          try {
            pageIds = JSON.parse(sched.pages || "[]");
          } catch {
            pageIds = [];
          }
        }

        if (!pageIds.length) {
          setError("No pages linked to this schedule.");
          setPagesData([]);
          setLoading(false);
          return;
        }

        // Fetch pages
        const { data: allPages, error: pageErr } = await supabase
          .from("pages")
          .select("*")
          .in("id", pageIds);
        if (pageErr) throw pageErr;

        const orderedPages = ttlPagesOrdered
          .map((id) => allPages.find((p) => p.id === id))
          .filter(Boolean);


        // Collect rows
        const allRowIds = orderedPages.flatMap((p) => {
          if (Array.isArray(p.rows)) return p.rows;
          try {
            return JSON.parse(p.rows || "[]");
          } catch {
            return [];
          }
        });


        const { data: rows, error: rowErr } = await fetchInChunks(
          "row_data",
          "id, row_header, row_layout, row_items, row_width, row_height",
          "id",
          allRowIds
        );
        if (rowErr) throw rowErr;


        // Collect tiles
        const allTileIds = rows.flatMap((r) =>
          (r.row_items || []).map((it) => it.tid)
        );
        const { data: tiles, error: tileErr } = await fetchInChunks(
          "tiles",
          "*",
          "tid",
          allTileIds
        );
        if (tileErr) throw tileErr;




        const mergedPages = orderedPages.map((page) => {
          const { rowOrder, tileOrder } = getTTLOutline(ttlArray, page.id);

          let finalRowIds = [];

          if (rowOrder.length > 0) {

            finalRowIds = rowOrder;
          } else {
            finalRowIds = Array.isArray(page.rows)
              ? page.rows
              : JSON.parse(page.rows || "[]");
          }

          const combinedRows = finalRowIds
            .map((rid) => {
              const row = rows.find(r => r.id === rid);
              if (!row) return null;

              // 2️⃣ Decide tile order:
              let tileOrderList = tileOrder[rid] || [];

              let finalTiles;
              if (tileOrderList.length > 0) {
                // TTL tile order
                finalTiles = tileOrderList
                  .map(tid => {
                    const tile = tiles.find(t => t.tid === tid);
                    const raw = (row.row_items || []).find(it => it.tid === tid);
                    return tile ? { ...raw, ...tile } : null;
                  })
                  .filter(Boolean);
              } else {
                // fallback: DB order
                finalTiles = (row.row_items || []).map(it => {
                  const tile = tiles.find(t => t.tid === it.tid);
                  return tile ? { ...it, ...tile } : it;
                });
              }

              return { ...row, row_items: finalTiles };
            })
            .filter(Boolean);

          return { ...page, rows: combinedRows };
        });


        setPagesData(mergedPages);


        mergedPages.forEach((page, pIndex) => {
        

          if (!page.rows || page.rows.length === 0) {
           
            return;
          }

          page.rows.forEach((row, rIndex) => {
           

            if (!row.row_items || row.row_items.length === 0) {
             
              return;
            }

            row.row_items.forEach((tile, tIndex) => {
            
            });
          });
        });

       


        console.group("📦 BEFORE LIVE FILTER — FULL MERGED DATA");

        mergedPages.forEach((page) => {
          console.group(`📄 Page ${page.id} — ${page.page_name}`);

          if (!page.rows?.length) {
          } else {
            page.rows.forEach((row) => {
              console.group(`  🧱 Row ${row.id} — ${row.row_header}`);


              (row.row_items || []).forEach((t) => {
                
              });

              console.groupEnd();
            });
          }

          console.groupEnd();
        });

        console.groupEnd();


        console.group("📦 BEFORE LIVE FILTER — MERGED FULL DATA");



        mergedPages.forEach((p, pi) => {
          console.group(`📄 Page ${pi + 1}: ${p.id} — ${p.page_name}`);

          if (!p.rows?.length) {
          
          } else {
            p.rows.forEach((r, ri) => {
              console.group(`  🧱 Row ${ri + 1}: ${r.id} — ${r.row_header}`);
             

              r.row_items?.forEach((item, ti) => {
               
              });

              console.groupEnd();
            });
          }

          console.groupEnd();
        });

        console.groupEnd();

        if (mergedPages.length > 0) setSelectedPage(mergedPages[0]);


      } catch (err) {
        console.error("❌ Error loading schedule preview:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [showModal, scheduleId]);

  const filteredPages = useMemo(() => {
    if (!liveOnly) return pagesData;

    const now = new Date();

    return pagesData
      .map((page) => {
        const livePage = liveTTL.find((lp) => lp.pid === page.id);
        if (!livePage) return null;

        const pageStart = new Date(livePage.st);
        const pageEnd = new Date(livePage.et);
        const pageLive = now >= pageStart && now <= pageEnd;

        if (!pageLive) return null;

        const filteredRows = (page.rows || [])
          .map((row) => {
            const ttlRow = livePage.rows.find((lr) => lr.rid === row.id);

            // no row TTL → inherit page
            const rowStart = ttlRow?.st ? new Date(ttlRow.st) : pageStart;
            const rowEnd = ttlRow?.et ? new Date(ttlRow.et) : pageEnd;

            const rowLive = now >= rowStart && now <= rowEnd;
            if (!rowLive && (!ttlRow?.tiles || ttlRow.tiles.length === 0))
              return null;

            // filter tiles
            const filteredTiles = (row.row_items || []).filter((item) => {
              const t = ttlRow?.tiles?.find((lt) => lt.tid === item.tid);

              const tileStart = t?.st ? new Date(t.st) : rowStart;
              const tileEnd = t?.et ? new Date(t.et) : rowEnd;

              return now >= tileStart && now <= tileEnd;
            });

            if (!rowLive && filteredTiles.length === 0) return null;

            return { ...row, row_items: filteredTiles };
          })
          .filter(Boolean);

        if (filteredRows.length === 0) return null;

        return { ...page, rows: filteredRows };
      })
      .filter(Boolean);
  }, [liveOnly, pagesData, liveTTL]);




  useEffect(() => {
    if (!liveOnly) {
      // LIVE OFF: Show full page, keep current page if possible
      if (pagesData.length > 0) {
        const fullPage = pagesData.find((p) => p.id === selectedPage?.id);
        setSelectedPage(fullPage || pagesData[0]);
      }
    } else {
      // LIVE ON: Show filtered page, keep current page if available
      if (filteredPages.length > 0) {
        const livePage = filteredPages.find((p) => p.id === selectedPage?.id);
        setSelectedPage(livePage || filteredPages[0]);
      } else {
        setSelectedPage(null); // No live pages available
      }
    }
  }, [liveOnly, pagesData, filteredPages, selectedPage?.id]);


  useEffect(() => {
    if (!showModal || !scheduleMeta) return;

    const fetchUI = async () => {
      const { data } = await supabase
        .from("sessionUI")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(1)
        .single();

      if (!data) return;

      const allowTheme =
        (data.brand.length === 0 || scheduleMeta.brand.some(b => data.brand.includes(b))) &&
        (data.vendor.length === 0 || scheduleMeta.vendor.some(v => data.vendor.includes(v))) &&
        (data.factory.length === 0 || scheduleMeta.factory.some(f => data.factory.includes(f)));

      setUiTheme(
        allowTheme
          ? {
            background: data.background_color || "#000000",
            tileFocus: data.tile_focus_color || "#ffffff",
            orbFocus: data.orb_focus_color || "#ffffff",
          }
          : {
            background: "#000000",
            tileFocus: "#ffffff",
            orbFocus: "#ffffff",
          }
      );
    };

    fetchUI();
  }, [showModal, scheduleMeta]);




  const normalizePosterPath = (raw) => {
    if (!raw) return null;
    const val = raw.startsWith("tiles/") ? raw : `tiles/${raw}`;
    return `${minioBaseUrl}${val}`;
  };


  return (


    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      customClasses="fixed inset-0 w-screen h-screen p-0 shadow-none overflow-hidden"
    >

      <style>
        {`
  #modal {
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
  }
`}
      </style>



      {/* <div className="relative w-full max-w-6xl flex justify-center "> */}
      <div
        className="
    fixed inset-0
    w-full h-full
    overflow-y-auto overflow-x-hidden
    hide-scrollbar
    bg-gradient-to-b from-[#0b0f1a] via-[#0a1224] to-[#020617]
    text-white
    box-border
    
  "
      >


        <div
          className="tv_screen relative w-full min-h-screen overflow-y-auto overflow-x-hidden text-white p-6"
          style={{ backgroundColor: uiTheme.background }}
        >


          {/* Header always visible */}


          {/* 🧭 Header with Page Tabs instead of Schedule Title */}
          <header className="text-white mb-8 flex justify-between items-center">
            {/* 🎞️ Scrollable Page Tabs */}
            <div className="flex-1 overflow-hidden">
              <Swiper
                spaceBetween={15}
                slidesPerView={"auto"}
                grabCursor
                style={{ overflow: "visible" }}
                className="!pb-1"
              >
                {filteredPages.map((page) =>


                (


                  <SwiperSlide
                    key={page.id}
                    style={{ width: "100px" }}
                    className="flex-shrink-0"
                  >


                    <div
                      onClick={() => {
                        // First click on a different page → just preview in TV
                        if (selectedPage?.id !== page.id) {
                          setSelectedPage(page);
                          return;
                        }

                        // Click again on same page → go to edit
                        navigate(`/page/${page.id}`);
                      }}
                      onDoubleClick={() => {
                        // Double click always goes to edit
                        navigate(`/page/${page.id}`);
                      }}
                      className="cursor-pointer rounded-md px-[4px] py-1 text-center text-[16px] transition-all relative hover:scale-105"
                      style={{
                        color: selectedPage?.id === page.id ? uiTheme.orbFocus : "#ccc",
                      }}
                    >
                      <h2 className="font-semibold truncate">{page.page_name}</h2>

                      {selectedPage?.id === page.id && (
                        <div
                          style={{
                            height: "6px",
                            width: "6px",
                            backgroundColor: uiTheme.orbFocus,
                            borderRadius: "50%",
                            margin: "6px auto 0",
                            boxShadow: `0 0 8px ${uiTheme.orbFocus}`,
                          }}
                        />
                      )}
                    </div>



                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* ⏱️ Time & Live Button (unchanged) */}
            <div className="flex items-center gap-4 ml-4 flex-shrink-0">
              <button
                onClick={() => setLiveOnly((prev) => !prev)}
                className={`px-3 py-1.5 rounded-md text-sm font-semibold ${liveOnly ? "bg-green-500 text-black" : "bg-gray-700 text-white"
                  }`}
              >
                {liveOnly ? "LIVE: ON" : "LIVE: OFF"}
              </button>
              <h1 className="text-lg font-semibold">{time}</h1>
            </div>
          </header>


          {loading ? (
            <div className="flex justify-center items-center h-full text-gray-400">
              Loading schedule preview...
            </div>
          ) : error ? (
            <div className="flex justify-center items-center h-full text-gray-500 italic">
              {error}
            </div>
          ) : filteredPages.length === 0 ? (
            <div className="flex justify-center items-center h-full text-gray-500 italic">
              No pages found
            </div>
          ) : (
            <>

              {selectedPage ? (
                <div>

                  {selectedPage?.rows?.length > 0 ? (
                    selectedPage.rows.map((row) => (
                      <section key={row.id} className="mb-6">


                        <h3
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/row/${row.id}`);
                          }}
                          className="text-sm font-semibold mb-2 border-l-4 border-blue-500 px-3 py-1 cursor-pointer hover:opacity-80"
                        >
                          {row.row_header}
                        </h3>


                        <Swiper
                          spaceBetween={20}
                          slidesPerView={"auto"}
                          grabCursor
                          style={{ overflow: "visible" }}
                        >
                          {row.row_items.map((item, index) => (


                            <SwiperSlide
                              key={`${item.tid}-${index}`}
                              style={{ width: "auto" }}
                            >
                              {(() => {

                                const tileHasSize =
                                  item?.tileWidth != null &&
                                  item?.tileHeight != null &&
                                  item.tileWidth.toString().trim() !== "" &&
                                  item.tileHeight.toString().trim() !== "";

                                const rowHasSize =
                                  Number(row?.row_width) > 0 &&
                                  Number(row?.row_height) > 0;

                                // let width = "160px";
                                // let height = "9rem";

                                // if (tileHasSize) {
                                //   width = `${Number(item.tileWidth)}px`;
                                //   height = `${Number(item.tileHeight)}px`;
                                // } else if (rowHasSize) {
                                //   width = `${Number(row.row_width)}px`;
                                //   height = `${Number(row.row_height)}px`;
                                // }

                                let width;
let height;

if (row?.row_layout === "highlight" && tileHasSize) {
  // Highlight rows pool a mix of poster/portrait composites, each with its
  // own correct baked-in size — a row-level width/height override would
  // force every tile into one box and crop/stretch whichever ones don't
  // match it, so per-item tileWidth/tileHeight always wins here.
  width = `${Number(item.tileWidth)}px`;
  height = `${Number(item.tileHeight)}px`;
} else if (rowHasSize) {
  width = `${Number(row.row_width)}px`;
  height = `${Number(row.row_height)}px`;
} else if (tileHasSize) {
  width = `${Number(item.tileWidth)}px`;
  height = `${Number(item.tileHeight)}px`;
} else {
  const layout = row?.row_layout?.toLowerCase()?.trim() || "poster";

  const fallback =
    FALLBACK_DIMENSIONS[layout] || FALLBACK_DIMENSIONS.poster;

  const SCALE = 0.15;

  width = `${fallback.w }px`;
  height = `${fallback.h }px`;
}

                                console.log({
  title: item.title,
  width,
  height
},"tile dimensions");

                                const rawImg = getImageByRowLayout(item, row);
                                console.log("Raw image for tile", item.tid, ":", rawImg);
                                const imgSrc = rawImg
                                  ? resolveImage(rawImg)
                                  : "https://as1.ftcdn.net/v2/jpg/05/04/28/96/1000_F_504289605_zehJiK0tCuZLP2MdfFBpcJdOVxKLnXg1.jpg";

                                return (
                                  <>
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        // Highlight row items have no `tid` of
                                        // their own. `baseTid` is just the
                                        // generic tile whose background image
                                        // was pooled — the actual movie being
                                        // highlighted is the overlay tile, so
                                        // prefer `overlayTid`, falling back to
                                        // `baseTid` for slots with no overlay.
                                        navigate(`/tile/${item.tid || item.overlayTid || item.baseTid}`);
                                      }}
                                      className="relative border overflow-hidden group shadow-lg cursor-pointer"
                                      style={{
                                        borderColor: uiTheme.tileFocus,
                                        width,
                                        height,
                                      }}
                                    >
                                      <img
                                        src={imgSrc}
                                        alt={item.title}
                                        loading="lazy"
                                        className="w-full h-full object-cover transition-all duration-300 hover:scale-105 group-hover:opacity-90"
                                      />
                                    </div>

                                    <h3 className="text-sm mt-2 text-center font-semibold text-white whitespace-normal break-words line-clamp-3 leading-tight mx-auto max-w-44">
                                      {item.title}
                                    </h3>
                                  </>
                                );
                              })()}
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </section>
                    ))
                  ) : (
                    <p className="text-gray-500 italic">No rows found</p>
                  )}

                </div>
              ) : (
                <div className="text-center text-gray-500 italic">
                  Select a page to preview
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {/* </div> */}
    </Modal>
  );
}
